import React from 'react';
import Stylesheet from './Filter.module.css';
import DropMenu from '../../../../elements/DropMenu/DropMenu';
import Button from '../../../../elements/Button/Button';
import Input from '../../../../elements/Input/Input';
import Number from '../../../../elements/Number/Number';
import Datepicker from '../../../../elements/Datepicker/Datepicker';
import {firestore} from '@enigma/core/services';
import { ico_check, ico_trash } from '../../../../icon';
/**
 * Filter Operator Selector
 */
const Operator = (props) => {
    const metadata = props.metadata;
    const index = props.index;
    return (
        <DropMenu 
        placeholder="select an operator"
        values={['AND', 'OR', 'NOT']} 
        disabled={index === 0}
        default={metadata.operator}
        onChange={value => {
            if (metadata.operator === value) return;
            const current = metadata;
            current.operator = value;
            props.update(current);
        }} />
    )
}
/**
 * Filter Column Selector 
 */
const Column = (props) => {
    const metadata = props.metadata;
    const column = props.column;
    const schema = props.schema;
    return (
        <DropMenu 
        placeholder="select column"
        values={schema} 
        textProp="title" 
        default={column?.title}
        onChange={value => {
            if (metadata.column === value.name) return;
            const current = metadata;
            current.column = value.name;
            // reset due to column dependence
            current.operation = value.type === "branch" 
            ? "EQUALS" : null;
            current.value = null;
            props.update(current)
        }} />
    )
}
/**
 * Filter Operation Selector
 */
const Operation = (props) => {
    const metadata = props.metadata;
    const column = props.column;
    const index = props.index;
    const table = props.table;
    const app = props.app;
    const query = props.query;
    // identify operations based on selected column
    let operation = [];
    switch (column?.type) {
        case "number":
            operation = ["EQUALS", "GREATER THEN", "LESS THEN"];
            //if (isGroup) operation.push("AVERAGE", "SUM");
            break;
        case "timestamp":
        case "date":
        case "notify":
            operation = ["EQUALS", "GREATER THEN", "LESS THEN"];
            //if (isGroup) operation.push("AVERAGE DAYS", "SUM DAYS");
            break;
        case "file":
            operation = ["NAME LIKE", "SIZE GREATER THEN", "SIZE LESS THEN"];
            break;
        default:
            operation = index === 0 ? ["LIKE", "EQUALS", "GROUP BY"] : ["LIKE", "EQUALS"];
            break;
    }
    return (
        <DropMenu 
        placeholder="select a operation"
        values={operation} 
        disabled={column === undefined 
        || column?.type === "branch"}
        default={metadata.operation}
        onChange={async value => {
            if (metadata.operation === value) return;
            let current = metadata;
            if (value === "GROUP BY" || metadata.operation === "GROUP BY") {
                const response = await app.toggleMessageBox("confirm change of Group query", 
                `changing the query to/from 'Group' will clear any the proceeding queries, and
                also change the available options. Do you wish to continue?`, "yes_no");
                if (response === "no") return;
                current.value = "All";
                current.operation = value;
                const filters = [];
                filters.push(current);
                await firestore.doc(`${table.metadata.document}/queries/${query.id}`)
                .update({filters: filters, isGroup: value === "GROUP BY"})
                .then(_ => app.toggleToast(ico_check, 'query updated'));
                return;
            }
            current.operation = value;
            // reset operation dependences
            if (column?.type === "file")
                current.value = null;
            props.update(current);
        }} />
    )
}
/**
 * Filter Value
 */
const Value = (props) => {
    const metadata = props.metadata;
    const column = props.column;
    switch (column?.type) {
        case "branch":
            return (
                <DropMenu 
                placeholder="select branch"
                values={["suva", "nadi","lautoka","sigatoka",
                "ba","tavua","Rakiraki","labasa"]} 
                default={metadata.value}
                onChange={async value => {
                    if (value === metadata.value) return;
                    const current = metadata;
                    current.value = value;
                    props.update(current);
                }} />
            )
        case "number":
            return (
                <Number  
                placeholder="possible value" 
                disabled={!metadata.operation ? true : false}
                defaultValue={metadata.value}
                onBlur={value => {
                    if (value === metadata.value) return;
                    const current = metadata;
                    current.value = value;
                    props.update(current)
                }} />
            )
        case "timestamp":
        case "date":
        case "notify":
            return (
                <Datepicker 
                placeholder="possible value" 
                disabled={!metadata.operation ? true : false}
                defaultValue={metadata.value}
                onChange={value => {
                    if (value === metadata.value) return;
                    const current = metadata;
                    current.value = new Date(value).getTime();
                    props.update(current)
                }} />
            )
        default:
            return (
                <Input 
                placeholder="possible value" 
                disabled={!metadata.operation 
                || metadata.operation === "GROUP BY" ? true : false}
                defaultValue={metadata.value}
                onBlur={value => {
                    if (value === metadata.value) return;
                    const current = metadata;
                    current.value = value;
                    props.update(current)
                }} />
            )
    }
}

const Filter = (props) => {
    const table = props.table;
    const query = props.query;
    const metadata = props.metadata;
    const app = props.app;
    const index = props.index;
    const schema = [...table.schema, 
        {name: 'branch', title: 'branch', type: 'branch'}, 
        {name: 'author', title: 'author', type: 'author'},
        {name: 'timestamp', title: 'date added', type: 'timestamp'}];
    // identify filter column (if selected yet)
    const column = schema.find(({name}) => 
        name === metadata.column)
    // update query
    const update = (newMetadata) => {
        const filters = [...query.filters];
        filters[index] = newMetadata;
        firestore.doc(`${table.metadata.document}/queries/${query.id}`)
        .update({filters: filters}).then(_ => 
        app.toggleToast(ico_check, 'query updated'));
    }
    return (
        <div className={Stylesheet.Container}>
            <div className={Stylesheet.Operator}>
                <Operator 
                metadata={metadata} 
                update={update} 
                index={index} />
            </div>
            <div className={Stylesheet.Column}>
                <Column 
                metadata={metadata} 
                update={update} 
                column={column} 
                schema={schema} />
            </div>
            <div className={Stylesheet.Operation}>
                <Operation 
                metadata={metadata} 
                update={update} 
                column={column} 
                index={index}  
                app={app} 
                table={table}
                query={query} />
            </div>
            <div className={Stylesheet.Value}>
                <Value 
                metadata={metadata} 
                update={update} 
                column={column} />
            </div>
            <div className={Stylesheet.Controls}>
                <Button icon minimal onClick={async _ => {
                    const isGroupFilter = metadata.operation === "GROUP BY";
                    let message = `Are you sure you want to remove the filter, 
                    this operation can not be undone.`;
                    if (isGroupFilter) 
                        message = `Are you sure you want to remove the group filter,
                        this will also remove any proceeding filters, this operation 
                        can not be undone`;
                    const response = await app.toggleMessageBox("Confirm Filter Removal",message, "yes_no");
                    if (response === "no") return;
                    const current = query;
                    // clear filters if removing a primary group filter
                    if (isGroupFilter || query.filters.length === 1) current.filters = null;
                    else current.filters.splice(index, 1);
                    firestore.doc(`${table.metadata.document}/queries/${query.id}`)
                    .update(query)
                    .then(_ => app.toggleToast(ico_check, 'filter removed'));
                }}>{ico_trash}</Button>
            </div>
        </div>
    )
}

export default Filter;